module.exports = __webpack_public_path__ + "static/media/7.107ad1f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/units/7.svg
// module id = 412
// module chunks = 14